<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="10.5" stroke="#000"/>
  <path stroke="#000" d="M4 19.5l3.717-3.253A1 1 0 018.376 16h7.248a1 1 0 01.659.247L20 19.5"/>
  <circle cx="12" cy="10.5" r="3" stroke="#000"/>
</svg>
